import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { sanityClient } from "@/js/sanity/client";
import { urlForImage } from "@/js/sanity/image";
export default {
  name: "HomeComponent",
  data: function data() {
    return {
      fadeElements: [],
      parallaxVideos: [],
      showFirstContent: true,
      showSecondContent: false,
      emailAddress: "",
      posts: []
    };
  },
  mounted: function mounted() {
    var _this = this;
    // Initialize the scroll opacity effect
    this.initScrollFadeEffect();
    window.addEventListener("scroll", this.handleScroll);
    // Trigger initial calculation
    this.handleScroll();

    // Set timer to switch content
    setTimeout(function () {
      var firstContent = document.querySelector(".overlay-content-1");
      firstContent.classList.add("hide");
      var video = document.getElementById("background-video");

      // Wait for the slideOut animation to complete before changing state
      setTimeout(function () {
        _this.showFirstContent = false;
        _this.showSecondContent = true;

        // Wait for the DOM to update before adding the show class

        video.style.opacity = "0.3";
        var secondContent = document.querySelector(".overlay-content-2");
        secondContent.classList.add("show");
      }, 1000); // Match this with the animation duration
    }, 4000);
  },
  beforeDestroy: function beforeDestroy() {
    // Remove event listener when component is destroyed
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    redirectToAnchor: function redirectToAnchor(anchor) {
      window.location.href = anchor;
    },
    goToSubscribe: function goToSubscribe() {
      var _this$$route$query, _this$$route$query2;
      var query = {};
      if ((_this$$route$query = this.$route.query) !== null && _this$$route$query !== void 0 && _this$$route$query.utm_source) query.utm_source = (_this$$route$query2 = this.$route.query) === null || _this$$route$query2 === void 0 ? void 0 : _this$$route$query2.utm_source;
      this.$router.push({
        name: "subscribe",
        query: query
      });
    },
    goToSignIn: function goToSignIn() {
      var _this$$route$query3, _this$$route$query4;
      var query = {};
      if ((_this$$route$query3 = this.$route.query) !== null && _this$$route$query3 !== void 0 && _this$$route$query3.utm_source) query.utm_source = (_this$$route$query4 = this.$route.query) === null || _this$$route$query4 === void 0 ? void 0 : _this$$route$query4.utm_source;
      this.$router.push({
        name: "login",
        query: query
      });
    },
    goToTermsOfUse: function goToTermsOfUse() {
      return {
        name: "termsOfUse"
      };
    },
    goToTermsOfSales: function goToTermsOfSales() {
      return {
        name: "termsOfSales"
      };
    },
    initScrollFadeEffect: function initScrollFadeEffect() {
      // Get all elements with the scroll-fade-element class
      this.fadeElements = document.querySelectorAll(".scroll-fade-element");
      this.parallaxVideos = document.querySelectorAll(".parallax-video-container");
    },
    handleScroll: function handleScroll() {
      var _this2 = this;
      var viewportHeight = window.innerHeight;
      var viewportCenter = viewportHeight / 2;

      // Handle fade elements and parallax images together
      this.fadeElements.forEach(function (element, index) {
        var rect = element.getBoundingClientRect();
        var elementCenter = rect.top + rect.height / 2;

        // Calculate distance from center (as a percentage of half the viewport height)
        var distanceFromCenter = Math.abs(elementCenter - viewportCenter);
        var maxDistance = viewportHeight * 0.5;

        // Calculate opacity based on distance from center
        var opacity = 1 - distanceFromCenter / maxDistance;
        opacity = Math.max(0, Math.min(1, opacity));
        element.style.opacity = opacity;

        // Add animation class to section text when it's in view
        var sectionText = element.querySelector(".section-text");
        if (sectionText && opacity > 0.5) {
          sectionText.classList.add("animate");
        }

        // Handle parallax for corresponding image if it exists
        if (_this2.parallaxVideos[index]) {
          var parallaxImage = _this2.parallaxVideos[index];

          // Calculate how far the section is from the center
          var _distanceFromCenter = elementCenter - viewportCenter;
          var parallaxOffset = _distanceFromCenter * 0.2; // Adjust this value to control parallax intensity

          // Apply the transform
          parallaxImage.style.transform = "translate3d(0, ".concat(parallaxOffset, "px, 0)");
        }
      });
    },
    scrollToFirstSection: function scrollToFirstSection() {
      var firstSection = document.querySelector(".about-section-1");
      if (firstSection) {
        firstSection.scrollIntoView({
          behavior: "smooth"
        });
      }
    },
    getSubscribeRoute: function getSubscribeRoute() {
      var _this$$route$query5, _this$$route$query6;
      var query = {
        email: this.emailAddress
      };
      if ((_this$$route$query5 = this.$route.query) !== null && _this$$route$query5 !== void 0 && _this$$route$query5.utm_source) query.utm_source = (_this$$route$query6 = this.$route.query) === null || _this$$route$query6 === void 0 ? void 0 : _this$$route$query6.utm_source;
      return {
        name: "subscribe",
        query: query
      };
    },
    urlForImage: urlForImage
  },
  created: function created() {
    var _this3 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var query;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            query = "*[_type == \"post\"] | order(_createdAt desc) {\n        \"slug\": slug.current,\n        title,\n        shortTitle,\n        briefDescription,\n        mainImage\n      }";
            _context.next = 4;
            return sanityClient.fetch(query);
          case 4:
            _this3.posts = _context.sent;
            _context.next = 10;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            console.error("Error fetching posts:", _context.t0);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7]]);
    }))();
  }
};